export default __webpack_public_path__ + "static/media/eco-travel-tips.8be6608e.jpeg";